import './PrivacyPolicyView.css'

import { useNavigate } from 'react-router'

export function PrivacyPolicyView() {
  const navigate = useNavigate()
  return (
    <div className="privacy-policy-view">
      <h1 className="privacy-policy-view__title">Privacy Policy</h1>
      <p className="privacy-policy-view__effective">Effective Date: January 25, 2025</p>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">1. Information We Collect</h2>
        <p className="privacy-policy-view__text">We collect information you provide directly:</p>
        <ul className="privacy-policy-view__list">
          <li>Account information (name, email, password)</li>
          <li>Profile information (photos, bio, preferences)</li>
          <li>Communications with other members</li>
          <li>Feedback and correspondence with us</li>
        </ul>
        <p className="privacy-policy-view__text">We also collect information automatically:</p>
        <ul className="privacy-policy-view__list">
          <li>Device and browser information</li>
          <li>Usage data and activity logs</li>
          <li>Location data (with your permission)</li>
        </ul>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">2. How We Use Your Information</h2>
        <p className="privacy-policy-view__text">We use your information to:</p>
        <ul className="privacy-policy-view__list">
          <li>Provide and improve our services</li>
          <li>Match you with compatible members</li>
          <li>Communicate with you about your account</li>
          <li>Ensure safety and prevent fraud</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">3. Information Sharing</h2>
        <p className="privacy-policy-view__text">
          We do not sell your personal information. We may share information with:
        </p>
        <ul className="privacy-policy-view__list">
          <li>Other members (profile information you choose to share)</li>
          <li>Service providers who assist our operations</li>
          <li>Law enforcement when required by law</li>
        </ul>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">4. Data Security</h2>
        <p className="privacy-policy-view__text">
          We implement appropriate technical and organizational measures to protect your personal
          information. However, no method of transmission over the internet is completely secure.
        </p>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">5. Data Retention</h2>
        <p className="privacy-policy-view__text">
          We retain your information for as long as your account is active or as needed to provide
          services. You may request deletion of your account and associated data at any time.
        </p>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">6. Your Rights</h2>
        <p className="privacy-policy-view__text">You have the right to:</p>
        <ul className="privacy-policy-view__list">
          <li>Access your personal information</li>
          <li>Correct inaccurate information</li>
          <li>Delete your account and data</li>
          <li>Export your data</li>
          <li>Opt out of marketing communications</li>
        </ul>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">7. Cookies</h2>
        <p className="privacy-policy-view__text">
          We use cookies and similar technologies to maintain your session, remember your
          preferences, and understand how you use our service.
        </p>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">8. Changes to This Policy</h2>
        <p className="privacy-policy-view__text">
          We may update this Privacy Policy from time to time. We will notify you of significant
          changes by email or through the service.
        </p>
      </section>

      <section className="privacy-policy-view__section">
        <h2 className="privacy-policy-view__heading">9. Contact Us</h2>
        <p className="privacy-policy-view__text">
          If you have questions about this Privacy Policy, please contact us at{' '}
          <a href="mailto:privacy@revel.club" className="privacy-policy-view__link">
            privacy@revel.club
          </a>
          .
        </p>
      </section>

      <div className="privacy-policy-view__back">
        <button
          type="button"
          className="privacy-policy-view__back-link"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </div>
    </div>
  )
}
